module.exports = __webpack_public_path__ + "img/mobile_banner.beadc5db.png";